import { render } from "./DynamicCheckBox.vue?vue&type=template&id=5944954c&ts=true"
import script from "./DynamicCheckBox.vue?vue&type=script&lang=ts"
export * from "./DynamicCheckBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicCheckBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5944954c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5944954c', __exports__)) {
    api.reload('5944954c', __exports__)
  }
  
  module.hot.accept("./DynamicCheckBox.vue?vue&type=template&id=5944954c&ts=true", () => {
    api.rerender('5944954c', render)
  })

}


export default __exports__